import { render, staticRenderFns } from "./qandapage.vue?vue&type=template&id=57ff1e62&scoped=true"
import script from "./qandapage.vue?vue&type=script&lang=js"
export * from "./qandapage.vue?vue&type=script&lang=js"
import style0 from "./qandapage.vue?vue&type=style&index=0&id=57ff1e62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff1e62",
  null
  
)

export default component.exports